import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5AF5B660-DDD5-446A-8AC9-102776DBBBC9
 * name apple-keyboard-shift
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/apple-keyboard-shift.svg
 * tags
 */
export const AppleKeyboardShiftIcon = createSvgIcon(<><path d="M15,18V12H17.17L12,6.83L6.83,12H9V18H15M12,4L22,14H17V20H7V14H2L12,4Z" /></>, 'AppleKeyboardShiftIcon');
export default AppleKeyboardShiftIcon